import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchAPI from "../../utils/axios";

/**
 * Thunk for registering a new user.
 * 
 * @async
 * @function registerUser
 * @param {Object} user - The user object containing registration information.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} The user registration response data or an error message.
 */
export const registerUser = createAsyncThunk(
    'user/registerUser', async (user, thunkAPI) => {
        try {
            const response = await fetchAPI.post('/auth/register', user);
            return response.data;
        } catch (err) {
            let message = err.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

/**
 * Thunk for logging in a user.
 * 
 * @async
 * @function loginUser
 * @param {Object} user - The user object containing login credentials.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} The user login response data or an error message.
 */
export const loginUser = createAsyncThunk(
    'user/loginUser', async (user, thunkAPI) => {
        try {
            const response = await fetchAPI.post('/auth/login', user);
            return response.data;
        } catch (error) {
            let message = error.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

/**
 * Thunk for getting current logged in user info
 * 
 * @async
 * @function loginUser
 * @param {Object} user - The user object containing login credentials.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} The current user response data or an error message.
 */
export const getCurrentUser = createAsyncThunk(
    'user/currentUser', async (user, thunkAPI) => {
        try {
            const response = await fetchAPI.get('/auth/currentUser', user);
            return response.data;
        } catch (error) {
            let message = error.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
)


/**
 * Thunk for fetching all users.
 * 
 * @async
 * @function getAllUsers
 * @param {Object} users - The object containing any filters or parameters for fetching users.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} The response data containing all users or an error message.
 */
export const getAllUsers = createAsyncThunk(
    'user/allUsers', async (users, thunkAPI) => {
        try {
            const response = await fetchAPI.get('/users', users);
            return response.data;
        } catch (error) {
            let message = error.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);
